import styled from '@emotion/styled'
import { InputNumber } from 'rsuite'
import theme from '../../../../../../../../styles/theme'

export const StyledInputNumber = styled(InputNumber)`
  --rs-text-primary: ${theme.colors.veryVeryFadedText};
`
